import { render, staticRenderFns } from "./OrderCustomerDetail.vue?vue&type=template&id=d81f92f2"
import script from "./OrderCustomerDetail.vue?vue&type=script&lang=js"
export * from "./OrderCustomerDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderCustomerDetail.vue?vue&type=style&index=0&id=d81f92f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports